import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

export const useSettleTrade = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => tradesService.settle(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
